import { Injectable, signal, WritableSignal } from '@angular/core';
import { TravelRequestCardFormGroup } from '@components/request/travel-request-card/form-groups/travel-request-card.formgroup';

import { TravelCardViewModel } from '@models/request';

@Injectable({
    providedIn: 'root',
})
export class TravelViewModelService {
    public readonly travelCardViewModel: WritableSignal<TravelCardViewModel | undefined> = signal(undefined);

    public readonly travelFormGroup: WritableSignal<TravelRequestCardFormGroup | undefined> = signal(undefined);

    clearState() {
        this.travelCardViewModel.set(undefined);
        this.travelFormGroup.set(undefined);
    }
}
